import OSS from 'ali-oss'
import user from '@/api/pageApi/user.js'
export function ossUpload({ file }, onProgress, success, error) {
  user.getUserParams({ key: '' },res=>{
    var conf = res.data.oss;
    var key = `${conf.dirName}/${new Date().getTime()}-${file.name}`;
    let client = new OSS({
      region: conf.region,
      accessKeyId: conf.accessKeyId,
      accessKeySecret: conf.accessKeySecret,
      bucket: conf.bucketName
    });

    // 定义上传方法。
    async function multipartUpload () {
      try {
        // object-key可以自定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至当前Bucket或Bucket下的指定目录。
        let result = await client.multipartUpload(key, file, { 
          progress: function (p, checkpoint) {
            // 断点记录点。浏览器重启后无法直接继续上传，您需要手动触发上传操作。
            // console.log(p);
            // console.log(checkpoint);
            onProgress && onProgress({p: p});
          }
      })
      } catch(e){
        error && error(e);
      }
    }

    // 开始分片上传。
    multipartUpload().then(() => {
      success && success({ url: `${conf.baseUrl}${key}` });
    });
  });

}
